import { AiFieldFilter } from 'module/types/filter-field/filter';

export enum Operation {
  GreaterThan = 'greaterThan',
  GreaterThanEqual = 'greaterThanEqual',
  LessThan = 'lessThan',
  LessThanEqual = 'lessThanEqual',
  IsEmpty = 'isEmpty',
  IsNotEmpty = 'isNotEmpty',
  Value = 'value',
  IsNot = 'isNot',
  HasValue = 'hasValue',
  Contains = 'contains',
  NotContains = 'notContains',
  IsNull = 'isNull',
  OneOf = 'oneOf',
  NoneOf = 'noneOf',
}
export enum SourceType {
  Task = 'task',
  Project = 'project',
  ProjectPhase = 'project-phase',
  Timesheet = 'timesheet',
  User = 'user',
  Phase = 'phase',
  Sprint = 'sprint',
  Company = 'company',
  Role = 'role',
  StarMeta = 'starmeta',
  Invoice = 'invoice',
  ResourceRequest = 'resourcerequest',
  RequestApproval = 'requestapproval',
  Financial = 'financial',
  Formula = 'formula',
  Meeting = 'meeting',
  Signal = 'signal_occurrence',
  Email = 'email',
}
export interface BaseFieldFilter {
  operation: Operation;
  value?: string;
  sourceType: SourceType;
}

export interface NativeFieldFilter extends BaseFieldFilter {
  name: string;
  key?: string;
}

export interface CustomFieldFilter extends BaseFieldFilter {
  fieldId: number;
  key?: string;
}
export interface SimpleFilter {
  nativeFields?: NativeFieldFilter[];
  customFields?: CustomFieldFilter[];
  aiFields?: Omit<AiFieldFilter, 'type'>[];
}

export enum QueryCombinerType {
  Any = 'any',
  All = 'all',
}
export interface SimpleSearchFilter extends SimpleFilter {
  match: QueryCombinerType;
}
export type SimpleSearchFieldFilter = NativeFieldFilter | CustomFieldFilter;
